export default __webpack_public_path__ + "static/media/Top 5 Promo Sept E-Commerce - 5.de77c573.jpg";